// extracted by mini-css-extract-plugin
module.exports = {"winnerPending":"_1F4G224iDbVnrIsja-sX2k"};